"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEqual(a, b) {
    return a === b;
}
exports.config = {
    production: isEqual('false', 'true'),
    hmr: isEqual('false', 'true'),
    services: {
        data: {
            endpoint: 'wss://data.buymyplace.com.au/v1/graphql',
        },
        googleMaps: {
            key: 'AIzaSyCz1Ju3vIpLEGEy8yke4eeUojbfh_-y3wM'
        },
        analytics: {
            segment: {
                enabled: isEqual('false', 'true'),
                writeKey: 'pbeELIVuXk7aoLyYmkFSqa94ihV1jxST',
            },
        },
        sentry: {
            sentryDsnVendor: 'https://c11b9d36e4ae476ca337005b814b4752@o402650.ingest.sentry.io/5569314',
        },
    },
    application: {
        branch: 'bmp-production',
        buildDate: 'Wed, 05 Jun 2024 10:48:07 GMT',
        buildNumber: '20240605_104805',
        version: '0.0.10',
        gitHead: '1b76a05'
    }
};
